export default class EthicalAdvice {
  content;
  constructor(data) {
    this.content = data.content;
  }
}
